export default __webpack_public_path__ + "static/media/Uber.fafebfc6.png";